<template>
  <div>
    <h6
      class="text-center text-gray"
      style="font-size: 12px;"
      v-html="getCaption('caption.copyright_traffic_jam_info')"
    ></h6>
    <div class="iframe-container">
        <iframe :src="iframesrc()"/>
    </div>
  </div>
</template>
<script>
import { transportationSchedule } from "@/constants/sidemenu.js";
import apiPath from "@/constants/api.js";

export default {
  created() {
    this.setSidemenu();
  },

  methods: {
    setSidemenu() {
      this.$store.dispatch("setSidemenuData", {
        menu: transportationSchedule,
        parentType: "topmenu"
      });
    },
    iframesrc() {
      return apiPath.schedule.traffic;
    }
  }
};
</script>